export const getInvoiceNumberDisplayedValue = (invoiceNumber?: number, invoiceNumberPrefix?: string | null): string => {
  if (!invoiceNumber) {
    return ''
  }

  const displayedPrefix = invoiceNumberPrefix?.trim()
  const invoiceNumberDisplayedValue = displayedPrefix ? `${displayedPrefix}-${invoiceNumber}` : `${invoiceNumber}`

  return invoiceNumberDisplayedValue
}
